import React from 'react';
import Typography, { TypographyProps } from '../Typography';

export const BarGradientLabel = ({
    label,
    typographyVariant,
    align
}: {
    label: string;
    typographyVariant?: TypographyProps['variant'];
    align?: TypographyProps['textAlign'];
}) => {
    const htype = typographyVariant ? typographyVariant : 'h4';
    const textAlign = align ? align : 'center';
    return (
        <Typography variant={htype} fontWeight={400} textAlign={textAlign}>
            {label}
        </Typography>
    );
};
